<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-nova-tarefa')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-tarefa')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
      >
        <el-form-item :label="$t('tarefa')" prop="task">
          <el-select v-model="ruleForm.task" :placeholder="$t('tarefa')">
            <el-option
              :label="$t('atualizaca-objetos-sro')"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('repetir-a-cada')" prop="repeat">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-input-number
              v-model="ruleForm.repeat"
              :min="1"
              :max="30"
            ></el-input-number>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-select v-model="ruleForm.execute" :placeholder="$t('tarefa')">
              <el-option :label="$t('dia')" value="1"></el-option>
              <el-option :label="$t('semanal')" value="2"></el-option>
              <el-option :label="$t('mensal')" value="3"></el-option>
              <el-option :label="$t('anual')" value="4"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.execute === '2'"
          :label="$t('dias')"
          prop="days"
        >
          <el-checkbox-group v-model="ruleForm.days">
            <el-checkbox-button label="7" :value="7" :key="7"
              >Dom</el-checkbox-button
            >
            <el-checkbox-button label="1" :value="1" :key="1"
              >Seg</el-checkbox-button
            >
            <el-checkbox-button label="2" :value="2" :key="2"
              >Ter</el-checkbox-button
            >
            <el-checkbox-button label="3" :value="3" :key="3"
              >Qua</el-checkbox-button
            >
            <el-checkbox-button label="4" :value="4" :key="4"
              >Qui</el-checkbox-button
            >
            <el-checkbox-button label="5" :value="5" :key="5"
              >Sex</el-checkbox-button
            >
            <el-checkbox-button label="6" :value="6" :key="6"
              >Sab</el-checkbox-button
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('horario')" prop="time">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-time-select
              v-model="ruleForm.time"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:45',
              }"
            ></el-time-select>
          </el-col>
        </el-form-item>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { UserService } from "@/services/users/user.services";
import { RoleService } from "@/services/role/role.services";
import { CustomerService } from "@/services/customers/customers.services";
import { TaskScheduleService } from "@/services/customers/task.schedule.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "ScheduleAdd",
  data() {
    return {
      id: "",
      ruleForm: {
        repeat: 1,
        days: [],
        time: "",
        task: "",
        execute: "1",
      },
      rules: {
        task: [
          {
            required: true,
            message: i18n.tc("tarefa-obrigatoria"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "schedule",
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      TaskScheduleService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.message,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          TaskScheduleService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("tarefa-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          TaskScheduleService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("usuario-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.message,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
